import React from 'react';
import { useModules } from '@go-client/go-modules/core/ModuleContext';
import { ExtensionPointRender } from '@go-client/go-modules/core/ExtensionPoints/Renderers';
import { ExtensionPointProps } from '@go-shared/types/go-modules/extensionPoints';
import { ContextExtensions } from '@go-shared/types/go-modules/goModules';

export const ExtensionPoint: React.FC<ExtensionPointProps> = ({
  namespace,
  data,
  events,
}): JSX.Element => {
  const { getExtensions } = useModules();
  const contextExtensions: ContextExtensions = getExtensions();

  return ExtensionPointRender(namespace, contextExtensions, data, events);
};
